import { useContext, useEffect } from 'react';

import { isNil } from 'lodash';
import mixpanel from 'mixpanel-browser';

import UserContext from 'components/UserContext';

import { trackMixpanelEventSdk } from './sdk';

const MIXPANEL_KEY = process.env.REACT_APP_MIXPANEL_KEY;

export const trackMixpanelEvent = (userId, eventName, eventData = {}) => {
  if (!isNil(MIXPANEL_KEY)) {
    mixpanel.track(eventName, { ...eventData, userId });
  }
};

export const trackMixpanelPageView = (userId, eventData = {}) => {
  if (!isNil(MIXPANEL_KEY)) {
    mixpanel.track_pageview({ ...eventData, userId });
  }
};

export const useMixpanelPageOpenTrack = (eventName) => {
  const { user } = useContext(UserContext);

  useEffect(() => {
    trackMixpanelEventSdk({
      user_id: user.id,
      event_name: eventName
    });
  }, [user.id, eventName]);
};

// Helper utility to safely read cookies
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const getClarityUserId = () => {
  const clarityCookie = getCookie('_clck');

  if (clarityCookie) {
    const decodedCookie = decodeURIComponent(clarityCookie);
    const clarityUserId = decodedCookie.split('^')[0];

    return clarityUserId;
  } else {
    // Fails silently for EU users without the cookie
    return null;
  }
};
